import { ShipmentReportTrayDto } from "src/app/proxy/dto";
import { TrayShipmentStatus } from "../../proxy/enums";

export class ShipmentReportTray implements ShipmentReportTrayDto {
    id: string;
    depositId?: string;
    journeyId?: string;
    dispatchNumber?: string;
    geneticMaterialId: number;
    geneticMaterialName?: string;
    trayQuantity: number;
    receptionedTrayQuantity: number;
    trayTypeCode?: string;
    trayTypeName?: string;
    seedlingsQuantity: number;
    receptionedSeedlingsQuantity: number;
    depositLocationId: number;
    depositName?: string;
    status?: TrayShipmentStatus;
    receiptNumber: number;
    plannedSeedlingsQuantity: number;
    plannedTrayQuantity: number;
    replacementTypeId: number;

    constructor(dto: ShipmentReportTrayDto) {
      const { seedlingsPerTray, declaredVSReceptionedTrays, declaredVSReceptionedPlants, ...rest } = dto;
      Object.assign(this, rest);
    }

    get seedlingsPerTray(): number {
      if (this.trayQuantity > 0) {
        return Math.round((this.seedlingsQuantity / this.trayQuantity) * 10) / 10;
      }
      return 0;
    }

    get declaredVSReceptionedTrays(): string {
      if (this.receptionedTrayQuantity > 0 && this.receptionedTrayQuantity !== this.trayQuantity) {
        return `${this.receptionedTrayQuantity}/${this.trayQuantity}`;
      }
      return this.trayQuantity.toString();
    }
  
    get declaredVSReceptionedPlants(): string {
      if (this.receptionedSeedlingsQuantity > 0 && this.receptionedSeedlingsQuantity !== this.seedlingsQuantity) {
        return `${this.receptionedSeedlingsQuantity}/${this.seedlingsQuantity}`;
      }
      return this.seedlingsQuantity.toString();
    }
  }